import * as React from 'react';

const SvgCookingTime: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle opacity={0.7} cx={12} cy={12} r={12} fill="white" />
      <path
        d="M21.75 12c0 5.386-4.365 9.75-9.75 9.75S2.25 17.387 2.25 12c0-5.384 4.365-9.75 9.75-9.75s9.75 4.366 9.75 9.75zM4.2 12a7.8 7.8 0 1015.6 0 7.8 7.8 0 00-15.6 0z"
        fill="white"
      />
      <path
        d="M12 3.226c0-.539.438-.98.973-.927a9.75 9.75 0 01.347 19.362c-.533.073-.986-.353-1.006-.89-.02-.539.403-.985.935-1.07a7.8 7.8 0 00-.277-15.44C12.438 4.195 12 3.765 12 3.227zM8.656 15.858c1.404 0 2.376-.81 2.376-1.962 0-.792-.468-1.449-1.305-1.638v-.036c.63-.216 1.134-.765 1.134-1.503 0-.972-.89-1.737-2.097-1.737-.8 0-1.575.315-2.088.801l.594.882c.54-.387.927-.531 1.36-.531.54 0 .98.297.98.828 0 .504-.414.855-1.062.855h-.747v1.098h.846c.657 0 1.107.369 1.107.909 0 .522-.423.9-1.152.9-.45 0-.963-.144-1.557-.513l-.522.99c.648.414 1.341.657 2.133.657z"
        fill="currentColor"
      />
      <path
        d="M14.529 15.858c1.872 0 2.673-1.656 2.673-3.438 0-1.782-.801-3.438-2.673-3.438-1.863 0-2.673 1.656-2.673 3.438 0 1.782.81 3.438 2.673 3.438zm0-1.152c-1.017 0-1.44-1.026-1.44-2.286 0-1.251.432-2.286 1.44-2.286 1.017 0 1.44 1.035 1.44 2.286 0 1.26-.414 2.286-1.44 2.286z"
        fill="currentColor"
      />
    </svg>
  );
};

export default SvgCookingTime;
